import React, { useState, useEffect } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { push } from 'connected-react-router';

import { useAppDispatch, useAppSelector } from 'js/store/hooks';
import { REDIRECT_ON_AUTH_KEY } from 'js/config/sessionStorageKeys';
import { validateCognitoSession } from 'js/shared/helpers/authHelper';
import { ROUTE_CODES } from 'js/config/routes';
import isElectron from 'js/shared/helpers/isElectron';

import { LOGIN_URL } from '../../config/config';

import LoadingSpinner from './LoadingSpinner';

const AuthenticatedComponent = ({ component: Component, ...rest }) => {
  const { currentUser, isAuthenticating } = useAppSelector(state => state.auth);
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    async function getAuth() {
      let session;
      try {
        session = await validateCognitoSession();
      } catch (error) {
        console.error(error);
      }

      if (session) {
        setLoading(false);
      } else {
        setLoading(false);
        if (isElectron()) {
          dispatch(push(ROUTE_CODES.DESKTOP_LOGIN));
        } else {
          window.sessionStorage.setItem(REDIRECT_ON_AUTH_KEY, `${location.pathname}${location.search}`);
          window.location.href = LOGIN_URL;
        }
      }
    }

    getAuth();

    // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Route
      {...rest}
      render={props => (
        <>
          {loading ? (
            <LoadingSpinner message={'Authenticating...'} />
          ) : (
            <Component {...props} currentUser={currentUser} isAuthenticating={isAuthenticating} />
          )}
        </>
      )}
    />
  );
};

export default AuthenticatedComponent;
